// extracted by mini-css-extract-plugin
export default {"ProviderImage":"ProviderView_ProviderImage__2o-P7"};